import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    data: {},
    error: null
}

export const fetchUser = createAsyncThunk(
    'user/fetchUser',
    async({token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/user/`,
                'GET',
                null,
                customHeaders
            )

            return response
        } catch (error) {
            return(rejectWithValue(error));
        }
    }
);

const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUser.pending, (state) => {
                state.error = null;
            })
            .addCase(fetchUser.fulfilled, (state, action) => {
                state.data = action.payload.data;
            })
            .addCase(fetchUser.rejected, (state, action) => {
                state.data = {};
                state.error = action.payload;
            })
    }
});

export default userSlice.reducer;